/** @format */

import {
  buildSearchNoResultsParams,
  buildSearchParams,
  buildSearchResultClickParams
} from 'src/analytics/buildGa4EventPayload';
import { trackGa4 } from 'src/analytics/trackGa4';
import type {
  Ga4SearchNoResultsParams,
  Ga4SearchParams,
  Ga4SearchResultClickParams
} from 'src/analytics/ga4Parameters';
import type { TrackGa4Options } from 'src/analytics/trackGa4';

export const GA4_SEARCH_LOCATION = Object.freeze({
  SEARCH_PAGE: 'search_page',
  HEADER: 'header'
});

export function trackSearchEvent(params: Ga4SearchParams = {}, options: TrackGa4Options = {}): void {
  trackGa4('search', buildSearchParams(params), options);
}

export function trackSearchNoResultsEvent(
  params: Ga4SearchNoResultsParams = {},
  options: TrackGa4Options = {}
): void {
  trackGa4('search_no_results', buildSearchNoResultsParams(params), options);
}

export function trackSearchResultClickEvent(
  params: Ga4SearchResultClickParams = {},
  options: TrackGa4Options = {}
): void {
  trackGa4('search_result_click', buildSearchResultClickParams(params), options);
}
